export const messages = {
    en: {},
    sv:{},
    fi:{},
    no:{},
    ru:{}
}